/**
 * A Logo atom to match a service to their logo, defaulting to Plerion when there is no match.
 * Example:
 * ```tsx
 *   <Logo serviceName="Plerion" />
 * ```
 */
export type SupportedLogo =
  | 'Plerion'
  | 'Slack'
  | 'Teams'
  | 'Email'
  | 'Webhook'
  | 'Jira'
  | 'JiraSecurity'
  | 'ServiceNow'
  | 'PagerDuty'
  | 'Kubernetes'
  | 'AWSAccount'
  | 'CWPPServiceAccount'
  | 'SecurityHub'
  | 'SQS'
  | 'S3'
  | 'AzureSubscription'
  | 'AzureActiveDirectory'
  | 'AzureMonitorLogs'
  | 'Sentinel'
  | 'GCPAccount'
  | 'GCPCloudAuditLogs'
  | 'ClickUp'
  | 'Vanta'
  | 'OpenAI'
  | 'CdrAws'
  | 'Drata'
  | 'Vanta'
  | 'ClickUp'
  | 'Linear'
  | 'Bitbucket'
  | 'GitHub'
  | 'GitLab'
  | 'G2';

export const Logo = ({
  className = '',
  name,
}: {
  className?: string;
  name: SupportedLogo;
}) => (
  <img
    src={`/images/logos/${getLogoImage(name)}`}
    alt={name + ' logo'}
    className={`h-8 w-8 rounded-md object-contain ${className}`}
  />
);

const getLogoImage = (name: SupportedLogo) => {
  const lowercaseType = name.toLowerCase();
  switch (lowercaseType) {
    case 'slack':
      return 'slack.png';
    case 'teams':
      return 'microsoft-teams.png';
    case 'servicenow':
      return 'service-now.png';
    case 'jira':
      return 'jira.svg';
    case 'jirasecurity':
      return 'jira-security.png';
    case 'email':
      return 'email.png';
    case 'pagerduty':
      return 'pd.svg';
    case 'sentinel':
      return 'sentinel.png';
    case 'webhook':
      return 'webhook.svg';
    case 'securityhub':
      return 'security-hub.png';
    case 'sqs':
      return 'sqs.png';
    case 'awsaccount':
    case 'cwppserviceaccount':
      return 'aws.png';
    case 's3':
      return 'aws-s3.png';
    case 'azuresubscription':
    case 'azureactivedirectory':
      return 'azure.png';
    case 'azuremonitorlogs':
      return 'azure-monitor.png';
    case 'gcpaccount':
      return 'gcp.png';
    case 'gcpcloudauditlogs':
      return 'gcp-logs.png';
    case 'cdraws':
      return 'cdr.png';
    case 'kubernetes':
      return 'kubernetes.svg';
    case 'clickup':
      return 'clickup.png';
    case 'linear':
      return 'linear.png';
    case 'openai':
      return 'openai.png';
    case 'plerion':
      return 'logo-small.svg';
    case 'drata':
      return 'drata.svg';
    case 'vanta':
      return 'vanta.png';
    case 'bitbucket':
      return 'bitbucket.svg';
    case 'github':
      return 'github-black.svg';
    case 'gitlab':
      return 'gitlab.svg';
    case 'g2':
      return 'g2.svg';
  }
};
